"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.FLEET_LOCATION_ENDPOINT = {
    getCities: '/fleet/{{version}}/cities',
    getLocations: '/fleet/{{version}}/cities/{{cityUuid}}/locations?search=Pilot',
    getLocationDetails: '/fleet/{{version}}/locations/{{locationUuid}}',
    getSpotsUrl: '/fleet/{{version}}/cities/{{cityUuid}}/spots',
};
